import * as React from 'react'
import { Link } from 'gatsby';
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { House, Flower2, Route, Landmark, CircleArrowUp, Search } from 'lucide-react';
import LangButton from './lang-button';

const ToolBar = () => {

    return (
        <div className='fixed z-10 top-20 left-2'>
            <div className='rounded-full bg-white/70 py-2'>
                <div className='flex flex-col gap-4 w-12 px-2 items-center'>
                    <div>
                        <LangButton label="EN" />
                    </div>
                    <div>
                        <LangButton label="VN" />
                    </div>
                    <div className='h-0.5 w-full bg-gray-400'></div>
                    <div>
                        <AnchorLink to='/'className='p-0 hover:text-red-500' title='go home'>
                            <House strokeWidth={1} size={24} />
                        </AnchorLink>
                    </div>
                    <div>
                        <AnchorLink to='/#anchor-env' className=' hover:text-red-500' title='go environment'>
                            <Flower2 strokeWidth={1} size={24} />
                        </AnchorLink>
                        
                    </div>
                    <div>
                        <AnchorLink to='/#anchor-mekong' className='p-0 hover:text-red-500' title='go mekong'>
                            <Route strokeWidth={1} size={24} />
                        </AnchorLink>
                    </div>
                    <div>
                        <AnchorLink to='/#anchor-heritage' className='p-0 hover:text-red-500' title='go heritage'>
                            <Landmark strokeWidth={1} size={24} />
                        </AnchorLink>
                    </div>
                    <div>
                        <AnchorLink to='#anchor-top' className='p-0 hover:text-red-500' title='go top'>
                            <CircleArrowUp strokeWidth={1} size={24} />
                        </AnchorLink>
                    </div>
                    <div>
                        <Link to='/search' className='p-0 hover:text-red-500' title='search'>
                            <Search strokeWidth={1} size={24} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ToolBar
